import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatPaymentChannel, formatStatusPayment } from 'helpers/format'
import { Data, UpdatePaymentTypeReq } from 'Store/orders/types'
import InfoItem from './InfoItem'
import { Col, Row, Space, message } from 'antd'
import {
  OrderStatus,
  PaymentType,
  menuPaymentTypeForUpdate,
  menuPaymentTypePackageC,
  menuPaymentTypePackageCWithoutOnline,
} from 'helpers/constanst'
import LinkText from 'Components/text/LinkText'
import { Theme } from 'Components/common'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { SelectItem } from 'Components/form'
import { themeConfig } from 'config'
import { updatePaymentTypeAPI } from 'Store/orders/api'
import RootState from 'typings/RootState'
import { selectCurrentUser } from 'Store/user/selector'
import { selectUpdatePaymentEvent } from 'Store/orders/selector'
import { connect } from 'react-redux'
import { clearEventAction } from 'Store/orders/actions'
import { EventModal } from 'Components/modal'
import { useDispatch } from 'react-redux'

type Props = {
  detail?: Data
  isViewMode?: boolean
  onSuccess?: () => void
} & ReduxProps

const PaymentInfo: React.FunctionComponent<Props> = props => {
  const { detail, onSuccess = () => {}, isViewMode = true, currentUser, event } = props
  const isCreditCard = detail?.payment_detail?.payment_type === PaymentType.CREDIT
  const isCreditTerm = detail?.payment_detail?.payment_type === PaymentType.TRANSFER_CREDIT_TERM
  const hasRef = detail?.payment_detail?.payment_ref
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [paymentType, setPaymentType] = useState('')
  const isCanceled = detail?.order_status === OrderStatus.CANCEL
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct
  const dispatch = useDispatch()

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderCreditTerm = () => {
    return <Space>{formatPaymentChannel('')}</Space>
  }

  const onUpdatePaymentType = (type: string): void => {
    if (!detail?.id) return
    const req: UpdatePaymentTypeReq = {
      id: detail?.id || 0,
      payment_type: type,
    }

    dispatch(updatePaymentTypeAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onSave = () => {
    if (paymentType === '') {
      message.error('กรุณาเลือกช่องทางการชำระเงิน')
      return
    }
    onCloseModal()
    onUpdatePaymentType(paymentType || '')
  }

  const onOpenModal = () => {
    setPaymentType('')
    setShowPaymentModal(true)
  }

  const onCloseModal = () => {
    setPaymentType('')
    setShowPaymentModal(false)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  const PaymentTypeModal = (
    <ConfirmWithChild
      title={'เลือกช่องทางการชำระเงิน'}
      isShow={showPaymentModal}
      handleOk={onSave}
      handleCancel={onCloseModal}
      child={
        <Row style={{ textAlign: 'left' }} gutter={[16, 16]}>
          <Col span={24}>
            <SelectItem
              name={'payment_type'}
              label={''}
              isRequired={true}
              value={paymentType}
              menu={menuPaymentTypeForUpdate}
              placeHolder={'ช่องทางจ่ายเงิน'}
              onChange={(val: any): void => setPaymentType(val)}
              allowClear={false}
            />
          </Col>
          <Col>
            <WarningText>หมายเหตุ : หากกดยืนยันแล้ว จะไม่สามารถเปลี่ยนช่องทางการชำระเงินได้อีก</WarningText>
          </Col>
        </Row>
      }
      cancelBtnTxt="ปิด"
    />
  )

  return (
    <BoxWrapper>
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row gutter={[16, 16]}>
        <Col md={24} xs={24}>
          <Row justify="space-between">
            <Col>
              <BoxTitle>ข้อมูลการชำระเงิน</BoxTitle>
            </Col>
            {isCreditTerm && !isViewMode && !isCanceled && (
              <Col>
                <Link color={Theme.colors.primary} onClick={onOpenModal}>
                  เปลี่ยนช่องทางการชำระเงิน
                </Link>
              </Col>
            )}
          </Row>

          {renderInfo('ช่องทาง', formatPaymentChannel(detail?.payment_detail?.payment_type || ''))}
          {isCreditCard && renderInfo('หมายเลขบัตร', detail?.payment_detail?.credit_card?.credit_no)}
          {hasRef && renderInfo('หมายเลขอ้างอิง', detail?.payment_detail?.payment_ref)}
          {renderInfo('สถานะการชำระเงิน', formatStatusPayment(detail?.payment_status || ''))}
        </Col>
        {PaymentTypeModal}
      </Row>
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Link = styled(LinkText)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const WarningText = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectUpdatePaymentEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PaymentInfo)
